import type {ReactElement} from 'react';
import React from 'react';
import type {FailedMessageRowProps} from './failed-message-row.types';
import {FailedMessageType} from '@Components/ai-chat-window/ai-chat-window.types';
import {Icon} from '@Components/icon-v2';
import {Text, TextSize, TextType} from '@Components/text';
import styles from './failed-message-row.module.scss';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';

export function FailedMessageRow({...props}: FailedMessageRowProps): ReactElement {
  const getClassNames = (): string => {
    switch (props.message.failureType) {
      case FailedMessageType.TOO_MANY_REQUESTS:
      case FailedMessageType.INTERNAL_ERROR:
        return 'content-danger';
      case FailedMessageType.STOPPED:
        return '';
      default:
        throw new Error(`Unhandled failed message failureType: ${props.message.failureType} in getClassNames`);
    }
  };

  const getFailedClassNames = (): string => {
    return `${styles.failedMessage} ${getClassNames()}`;
  };

  const getFailedMessageIcon = (): string => {
    switch (props.message.failureType) {
      case FailedMessageType.INTERNAL_ERROR:
      case FailedMessageType.TOO_MANY_REQUESTS:
        return 'icon-arrow-right';
      case FailedMessageType.STOPPED:
        return 'icon-stop-video';
      default:
        throw new Error(`Unhandled failed message failureType: ${props.message.failureType} in getFailedMessageIcon`);
    }
  };

  const getFailedMessageText = (): string => {
    switch (props.message.failureType) {
      case FailedMessageType.INTERNAL_ERROR:
        return window.i18next.t('pmwjs_unexpected_error');
      case FailedMessageType.STOPPED:
        return window.i18next.t('pmwjs_request_stopped');
      case FailedMessageType.TOO_MANY_REQUESTS:
        return window.i18next.t('pmwjs_too_many_requests');
      default:
        throw new Error(`Unhandled failed message failureType: ${props.message.failureType} in getFailedMessageText`);
    }
  };

  const getFailedMessage = (): ReactElement => {
    return (
      <div className={getFailedClassNames()}>
        <Icon icon={getFailedMessageIcon()} shape={IconShape.CIRCLE} type={IconType.FLAT} size={IconSize.SIZE_ICON_12} />
        <Text val={getFailedMessageText()} className={'spacing-m-l-1'} type={TextType.BODY} size={TextSize.SMALL} />
        {props.showRetry ? (
          <Text
            type={TextType.BODY}
            onClick={() => {
              void props.onRetry();
            }}
            val={window.i18next.t('pmwjs_retry')}
            bold
            underline
            className={`_cursor-pointer spacing-m-l-1`}
            size={TextSize.SMALL}
          />
        ) : null}
      </div>
    );
  };

  return getFailedMessage();
}
